export const cleanNumber = (number, originalNumber) =>
	number
		? number
				.replace(/[^\d]/g, '')
				.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
		: originalNumber;

export const applyPhoneSwapping = (contactInfo, vehicleAccountId) => {
	if (!window?.phoneSwapping?.getNumber) return '';

	const swappedNumber = window.phoneSwapping.getNumber(
		contactInfo.number,
		contactInfo.type.toUpperCase(),
		vehicleAccountId
	);

	return cleanNumber(swappedNumber, contactInfo.number);
};
